// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3YUR-","content":"GlobalSearch_content__3B-_F"};